/** Key into StoryState.scores: "scoreName" for global, "characterId:scoreName" for character. */
export const scoreKey = (scoreName: string, characterId?: string): string =>
  characterId ? `${characterId}:${scoreName}` : scoreName
